import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from 'react-bootstrap-tabs';

import { Container } from 'reactstrap';
import EirButton from '../eir-button/EirButton';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import { css } from 'emotion';
import styled from '@emotion/styled'
import { isMobileOnly } from 'react-device-detect';
import EirTabTiles from './EirTabTiles'
import { LargeBusiness, moduleMargins, htmlWidget } from '../../Constants';

const EirTabModule = (props) => {
  const [activeTab, setActiveTab] = useState('0');
  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }
  const renderContent = (content) => {
    return { __html: content };
  }
  const isLBSite = (LargeBusiness.isLBSite);
  let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);
  const tabProps = {
    marginClass : (!isMobileOnly) ? marginDesktop : marginMobile,
    containerClass: (isLBSite) ? 'pt-4 pb-5 lb-tab-module-main' : 'pt-4 pb-5'
  }
  var counter = 1;
  const [tabSelectedCount, setTabSelectedCount] = useState(0);

  const [desktopCTA] = React.useState(props.DesktopBottomCTA);
  const [mobileCTA] = React.useState(props.MobileBottomCTA);
  const [desktopstylingCTA] = React.useState({
      backgroundColor: props.BottomCTAColor + " !important",
      color: props.BottomCTAFontColor,
      borderColor: props.BottomCTAOutlineColor,
      hover: {
          backgroundColor: props.BottomCTAHoverColor,
          color: props.BottomCTAFontColorHover,
          borderColor: props.BottomCTAHoverColor,
      }
  })
  const [mobilestylingCTA] = React.useState({
      backgroundColor: props.MobileBottomCTAColor + " !important",
      color: props.MobileBottomCTAFontColor,
      borderColor: props.MobileBottomCTAOutlineColor,
      hover: {
          backgroundColor: props.MobileBottomCTAHoverColor,
          color: props.MobileBottomCTAFontColorHover,
          borderColor: props.MobileBottomCTAHoverColor,
      }
  })

  let desktopCTAprops = (desktopCTA != undefined ? ({
      text : desktopCTA.text, 
      title : desktopCTA.title, 
      link : desktopCTA.link, 
      target: desktopCTA.target, 
      type : desktopCTA.type, 
      icon : desktopCTA.icon,
      buttonStyle : desktopCTA.buttonStyle, 
      buttonSize : desktopCTA.buttonSize,
      theme : desktopCTA.theme,
      videoModal : desktopCTA.VideoModal,
      styling : desktopstylingCTA

  }) : {});

  let mobileCTAprops = (mobileCTA != undefined ? ({
      text : mobileCTA.text, 
      title : mobileCTA.title, 
      link : mobileCTA.link, 
      target: mobileCTA.target, 
      type : mobileCTA.type, 
      icon : mobileCTA.icon,
      buttonStyle : mobileCTA.buttonStyle, 
      buttonSize : mobileCTA.buttonSize,
      theme : mobileCTA.theme,
      videoModal : mobileCTA.VideoModal,
      styling : mobilestylingCTA

  }) : {});

  useEffect(() => {

    if (document.getElementById("tab-module-ctr-" + props.TabModuleOccurance)) {

      let getParentReference = document.getElementById("tab-module-ctr-" + props.TabModuleOccurance);
      let navActiveColor = getParentReference.querySelector(".nav-tabs .active")

      var windowComponents = window.components;
      var tabModuleComponents = [];
      // loop to find the tabmodules in window components
      for (var i = 0; i < windowComponents.length; i++) {
        if (windowComponents[i].type == "eir-tab-module") {
          tabModuleComponents.push(windowComponents[i]);
        }
      }
      //loop to add the css for tabs


      for (var j = 0; j < tabModuleComponents.length; j++) {
        if (tabModuleComponents[j].cmsContent.TabModuleOccurance == props.TabModuleOccurance) {
          navActiveColor.style = "background-color:" + (isMobileOnly ? tabModuleComponents[j].cmsContent.MobileTabSelectedColor : tabModuleComponents[j].cmsContent.TabSelectedColor)  +";" +
          "color:" + (isMobileOnly ? tabModuleComponents[j].cmsContent.MobileTabSelectedFontColor : tabModuleComponents[j].cmsContent.TabSelectedFontColor) + " !important;" +
          "border-bottom: 2px solid" + (isMobileOnly ? tabModuleComponents[j].cmsContent.MobileTabSelectedColor : tabModuleComponents[j].cmsContent.TabSelectedColor);
        }
      }


      setTimeout(function () {
        var tiles = getParentReference.querySelectorAll(".tab-font");
        var Tabs = [];
        for (var a = 0; a < tiles.length; a++) {
          Tabs.push(parseInt(tiles[a].clientHeight));
        }
        for (var b = 0; b < tiles.length; b++) {
          tiles[b].style.height = Math.max.apply(Math, Tabs) + "px";
        }
      }, 0);

    }

    /* make the tab selected if the url is /about-eir-business --- changes to be made in open cms also - add data-link attribute to the tab-title 
    and the url #name should match the data-link name - so that the required tab can be clicked on load   ---- EIR-596
    */
    if ((location.href.indexOf("/about-eir-business/#") > 0) && tabSelectedCount == 0) {
      let getTabToBeSelected = location.href.substr(location.href.lastIndexOf("#") + 1, location.href.length);
      if (getTabToBeSelected != null || getTabToBeSelected != undefined) {
        if (document.querySelector(".internal-link-" + getTabToBeSelected) != undefined) {
          document.querySelector(".internal-link-" + getTabToBeSelected).click();
          setTabSelectedCount(1);
        }
      }
    }

  })

  // To provide the width depending on tab counts
  const tabWidth = () => {
    switch (props.desktoptabs.length) {
      case 1:
        return '40%';
      case 2:
        return '50%';
      case 3:
        return '33.33%';
      case 4:
        return '25%';
      case 5:
        return '20%';
      case 6:
        return '16.66%';
    }
  }
  const mobileTabWidth = () => {
    switch (props.mobiletabs.length) {
      case 1:
        return '70%';
      case 2:
        return '50%';
      case 3:
        return '33%';
    }
  }

  //To add css for tabs
  const NavLink = styled.div`
  background-color: ${(isMobileOnly ? props.MobileTabColor : props.TabColor)} !important;
  color: ${(isMobileOnly ? props.MobileTabFontColor : props.TabFontColor)} !important;
  cursor:pointer;

  &:hover{
    background-color: ${(isMobileOnly ? props.MobileTabHoverColor : props.TabHoverColor)} !important;
    color: ${(isMobileOnly ? props.MobileTabHoverFontColor : props.TabHoverFontColor)} !important;
  }
  &.active{
    border-bottom-color: ${(isMobileOnly ? (props.MobileTabColor && !props.MobileTabSelectedColor ? "#343A40" : props.MobileTabSelectedColor)
      : (props.TabColor && !props.TabSelectedColor ? "#343A40" : props.TabSelectedColor))} !important;
  }
`

  return (
    <div>
      {(!isMobileOnly) && (props.HideComponent != "Desktop" && props.HideComponent != "Both") &&
        <div className={`${tabProps.containerClass} ${tabProps.marginClass}`} style={{
          backgroundImage: "url(" + (props.backgroundImage ? props.backgroundImage.path : '') + ")",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: props.backgroundColor,
        }}>
          <div className={`homepage-modules-title container ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.DesktopTitle)}></div>

          <Container id={"tab-module-ctr-" + props.TabModuleOccurance} className="mt-4 nav-center business-tab-module-main">

            <Nav tabs className="d-flex justify-content-center align-items-center">
              {props.desktoptabs.map((tile, i) => {
                return (
                  <NavItem key={i} className={(css`width:${tabWidth()} `)}>
                    <Card className="tab_card  ml-2 mr-2">
                      <NavLink 
                        className={"d-flex justify-content-center align-items-center tab-font p-3 " + classnames({ active: activeTab === (i).toString() })}
                        //className={'tab-font p-3' + (css`background-color: ${props.TabColor}; color: ${props.TabFontColor} !important ;`)}
                        onClick={() => { toggle((i).toString()); }}
                        dangerouslySetInnerHTML={renderContent(tile.TabTitle)}
                      >
                      </NavLink>
                    </Card>
                  </NavItem>
                );
              })
              }
            </Nav>

            <Card className="three_six_card">
              <TabContent activeTab={activeTab}>
                {props.desktoptabs.map((tile, i) => {
                  return (
                    <TabPane key={i} tabId={i.toString()}>
                      <EirTabTiles tab={tile} Image1={tile.LeftImage} Image2={tile.RightImage} BottomImage={tile.BottomImage} Text1={tile.LeftText} Text2={tile.RightText}></EirTabTiles>
                    </TabPane>
                  );
                })
                }
              </TabContent>
            </Card>
            <div className="pt-4">
              {props.DesktopBottomCopy &&
                <div className="pt-2 bottomcopy homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.DesktopBottomCopy)}></div>
              }
              {props.DesktopBottomCTA && props.DesktopBottomCTA.type != 'arrow' &&
                <div className='d-flex justify-content-center align-items-center lb-tab-margin-padding'>
                  <EirButton  {...desktopCTAprops} databundlecode={props.id}
                    outline={true}
                    className={((props.DesktopBottomCopy) ? 'm-2 ' : 'm-3 ') + "float-left js-prequal-modal-btn cta_threesix ls-0 " + props.DesktopBottomCTA.type == 'button' ? "eir-text-secondary p-2 "  : "link_threesix " }
                  />
                </div>
              }
            </div>

          </Container>
        </div>
      }

      {(isMobileOnly) && (props.HideComponent != "Mobile" && props.HideComponent != "Both") &&
        <div className={`${tabProps.containerClass} ${tabProps.marginClass}`} style={{
          backgroundImage: "url(" + (props.mobileBackgroundImage ? props.mobileBackgroundImage.path : '') + ")",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: props.mobileBackgroundColor,
        }}>
          <div className={`homepage-modules-title container ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.MobileTitle)}></div>

          <Container id={"tab-module-ctr-" + props.TabModuleOccurance} className="mt-4 nav-center business-tab-module-main">

            <Nav tabs className="d-flex justify-content-center align-items-center">
              {props.mobiletabs.map((tile, i) => {
                return (
                  <NavItem key={i} className={(css`width:${mobileTabWidth()} `)}>
                    <Card className="tab_card  ml-1 mr-1">
                      <NavLink
                        className={"d-flex justify-content-center align-items-center tab-font p-3 " + classnames({ active: activeTab === (i).toString() })}
                        //className={'tab-font p-3' + (css`background-color: ${props.TabColor}; color: ${props.TabFontColor} !important ;`)}
                        onClick={() => { toggle((i).toString()); }}
                        dangerouslySetInnerHTML={renderContent(tile.TabTitle)}
                      >
                      </NavLink>
                    </Card>
                  </NavItem>
                );
              })
              }
            </Nav>
            <Card className="three_six_card">
              <TabContent activeTab={activeTab}>
                {props.mobiletabs.map((tile, i) => {
                  return (
                    <TabPane key={i} tabId={i.toString()}>
                      <EirTabTiles tab={tile} Image1={tile.TopImage} Image2={tile.BottomImage} BottomImage={tile.BottomImage2} Text1={tile.TopText} Text2={tile.BottomText}></EirTabTiles>
                    </TabPane>
                  );
                })
                }
              </TabContent>
            </Card>

            <div className="pt-4">
              {props.MobileBottomCopy &&
                <div className={"pt-2 bottomcopy homepage-modules-title "+ htmlWidget} dangerouslySetInnerHTML={renderContent(props.MobileBottomCopy)}></div>
              }
              {props.MobileBottomCTA && props.MobileBottomCTA.type != 'arrow' &&
                <div className='d-flex justify-content-center align-items-center lb-tab-margin-padding'>
                  <EirButton  {...mobileCTAprops} databundlecode={props.id}
                    outline={true}
                    className={((props.MobileBottomCopy) ? 'm-2 ' : 'm-3 ') + "float-left js-prequal-modal-btn cta_threesix ls-0 " + props.MobileBottomCTA.type == 'button' ? "eir-text-secondary p-2 " : "link_threesix "}
                  />
                </div>
              }
            </div>
          </Container>
        </div>
      }
    </div>
  )
}
export default EirTabModule;

